type BreadcrumbItem = {
    name: string
    url: string
}

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[]) {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url,
        })),
    }
}

type ProductJsonLdParams = {
    name: string
    description?: string
    image: string
    sku?: string
    brand?: string
    price?: number
    priceCurrency?: string
    availability: 'InStock' | 'OutOfStock'
    url: string
}

export function buildProductJsonLd(params: ProductJsonLdParams) {
    return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: params.name,
        description: params.description,
        image: params.image,
        sku: params.sku,
        brand: params.brand
            ? {
                  '@type': 'Brand',
                  name: params.brand,
              }
            : undefined,
        offers: {
            '@type': 'Offer',
            price: params.price,
            priceCurrency: params.priceCurrency ?? 'EUR',
            availability: `https://schema.org/${params.availability}`,
            url: params.url,
        },
    }
}

type OrganizationJsonLdParams = {
    name: string
    url: string
    logo: string
}

export function buildOrganizationJsonLd(params: OrganizationJsonLdParams) {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: params.name,
        url: params.url,
        logo: params.logo,
    }
}

type WebSiteJsonLdParams = {
    name: string
    url: string
}

export function buildWebSiteJsonLd(params: WebSiteJsonLdParams) {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: params.name,
        url: params.url,
    }
}

type ItemListJsonLdItem = {
    url: string
    name: string
    image?: string
    position: number
}

export function buildItemListJsonLd(items: ItemListJsonLdItem[]) {
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: items.map((item) => ({
            '@type': 'ListItem',
            position: item.position,
            url: item.url,
            name: item.name,
            image: item.image,
        })),
    }
}

export function jsonLdScript(data: object) {
    return {
        type: 'application/ld+json',
        children: JSON.stringify(data),
    }
}
